import shopifyGenericDefaults from '../shopify-generic/config.js';
import { ConvermaxSecondaryMedia } from './custom-elements.js';

window.Convermax.toggleHeaderYmmVisibility = () => {
  window.document.querySelector('#cm-ymm-header')?.classList.toggle('cm_hide');
};

const ignoreFields = [
  'category',
  ...shopifyGenericDefaults.Widgets.find((w) => w.name === 'Facets').ignoreFields,
];

function responseHandler(response) {
  const pageType = window.Convermax.Shopify.getPageType();

  if (window.location.pathname === '/pages/search' || pageType === 'collection' || pageType === 'vendors') {
    const { Items } = response;
    if (!Items?.length) {
      return;
    }

    try {
      const newItems = Items.map((item) => {
        return {
          productId: +item.id,
          variantId: +item.variant_ids[0],
          regularPriceInCents: Math.round(item.price * 100),
          compareAtPriceInCents: item.compare_at_price ? Math.round(item.compare_at_price * 100) : null,
          handle: item.handle,
          vendor: item.vendor,
          url: item.url,
          collectionIds: item.collection_ids,
        };
      });

      window.Convermax.newItems = newItems;
    } catch (error) {
      console.error('Failed to create items', error);
    }
  }

  return response;
}

const baseUpdateCallback = shopifyGenericDefaults.Widgets.find(
  (w) => w.name === 'SearchResult',
)?.updateCallback;

const updateCallback = () => {
  baseUpdateCallback?.();

  const universalSeparator = window.document.querySelector('.cm_universal-separator');
  const isUniversalGridEmpty = !!window.document.querySelector('.cmRepeater_items--universal:empty');
  const isVehicleSpecificGridEmpty = !!window.document.querySelector(
    '.cmRepeater_items--vehicle-specific:empty',
  );

  if (!isUniversalGridEmpty && !isVehicleSpecificGridEmpty) {
    universalSeparator.classList.remove('cm_hidden');
  } else {
    universalSeparator.classList.add('cm_hidden');
  }

  updateDiscountPrices();

  // Init custom elements after render
  setTimeout(async () => {
    // Define our copies of theme's custom elements, if they weren't on previous renders of this page load
    if (!customElements.get('convermax-secondary-media')) {
      window.customElements.define('convermax-secondary-media', ConvermaxSecondaryMedia);
    }
  }, 1);
};

function updateDiscountPrices() {
  const { newItems } = window.Convermax;
  if (!newItems?.length) {
    return;
  }

  // https://regiostech.crisp.help/en/article/dopp-api-reference-1gvya0h/#2-collection-page-new-items-event
  window.dispatchEvent(
    new CustomEvent('regios-dopp:collection-page:new-items', {
      detail: {
        newItems,
      },
    }),
  );
}

export default {
  ...shopifyGenericDefaults,
  includes: ['shopify-generic'],
  responseHandler,
  fitmentSearch: {
    ...shopifyGenericDefaults.fitmentSearch,
    onVehicleSelected: window.Convermax.toggleHeaderYmmVisibility,
  },
  Widgets: [
    ...shopifyGenericDefaults.Widgets.filter(
      (w) =>
        ![
          'SearchBox',
          'HeaderVehicleWidget',
          'Facets',
          'FilterChips',
          'SearchResult',
          'RelatedItems',
        ].includes(w.name),
    ),
    // theme search dialog click on search box input after open from header
    // on mobile view it trigger opening our dialog too
    {
      name: 'SearchBox',
      location: { selector: '#cm-search-box', class: 'cm-search-box' },
      onDropdownItemsReceived: shopifyGenericDefaults.Widgets.find((w) => w.name === 'SearchBox')
        .onDropdownItemsReceived,
      template: 'SearchBox',
      onSubmit: () => window.document.querySelector('search-drawer .button--close')?.click(),
    },
    {
      ...shopifyGenericDefaults.Widgets.find((w) => w.name === 'HeaderVehicleWidget'),
      name: 'GenericVehicleWidget',
    },
    {
      name: 'FilterChips',
      type: 'FacetPanel',
      ignoreFields,
    },
    {
      name: 'Facets',
      type: 'FacetPanel',
      initCollapsed: true,
      ignoreFields,
    },
    {
      name: 'HeaderVehicleWidget',
      type: 'VehicleWidget',
      location: { selector: '#cm-ymm-header', class: 'cm_hide' },
      template: 'fitmentSearch/headerVehicleWidget',
      isAlwaysActive: true,
      fields: shopifyGenericDefaults.Widgets.find((w) => w.name === 'HeaderVehicleWidget').fields,
    },
    {
      ...shopifyGenericDefaults.Widgets.find((w) => w.name === 'SearchResult'),
      updateCallback,
    },
    {
      ...shopifyGenericDefaults.Widgets.find((w) => w.name === 'RelatedItems'),
      onItemsRendered: updateCallback,
    },
    {
      name: 'SingleVehicleGarage_button',
      type: 'SingleVehicleGarage',
      location: {
        replace: '#vehicle-widget__open-btn',
        class: 'cm_vehicle-widget__open-button',
      },
      template: 'fitmentSearch/singleVehicleGarage',
    },
  ],
};
